<template>
  <v-app>
    <v-container>
      <v-layout row wrap>
        <v-flex lg12 md12 sm12 xs12>
          <div class="mb-3 mt-3">
            <h2>Pagos parciales</h2>
          </div>
          <div>
            <span
              ><router-link
                :to="{ path: '/mis-eventos' }"
                title="Ver todos mis eventos"
                ><u>Volver a Mis Eventos</u></router-link
              ></span
            ><span> > </span><span>Pagos parciales</span>
          </div>
          <div class="mt-3 mb-4"></div>
        </v-flex>
      </v-layout>
      <v-divider></v-divider>
      <v-layout row wrap>
        <v-flex lg4 md4 sm4 xs12 mb-3>
          <v-select
            item-value="id"
            item-text="code"
            :items="tipoIdentificaciones"
            label="Tipo de identificacion (*)"
            prepend-icon="account_box"
            v-model="data_busqueda.tipo_identificacion"
            required
          ></v-select>
        </v-flex>
        <v-flex lg4 md4 sm4 xs12 mb-3>
          <v-text-field
            prepend-icon="account_box"
            label="Identificacion usuario (*)"
            v-model="data_busqueda.numero_identificacion"
          ></v-text-field>
        </v-flex>
        <v-flex lg4 md4 sm4 xs12 mb-3>
          <v-text-field
            prepend-icon="dialpad"
            label="Número de Venta"
            v-model="data_busqueda.numero_venta"
            required
          ></v-text-field>
        </v-flex>        
        <v-flex lg3 md3 sm3 xs12 mb-3>
          <v-btn
            color="primary"
            @click="buscarVentasPagosParciales()"
            ><v-icon>search</v-icon> BUSCAR VENTAS</v-btn
          >
        </v-flex>
        <v-flex lg1 md1 sm1 xs12 mb-3></v-flex>
        <v-flex lg3 md3 sm3 xs12 mb-3>
          <v-btn color="error"
            @click="limpiarBusqueda"
            v-show="show_limpiarbusqueda"
            ><v-icon>delete</v-icon> LIMPIAR BUSQUEDA</v-btn
          >
        </v-flex>
      </v-layout>
      <v-divider></v-divider>
      <v-data-table
        v-if="venta_pago_parcial.length > 0"
        :headers="headers"
        :items="venta_pago_parcial"
        :items-per-page="pagination.per_page"
        :page.sync="pagination.current_page"
        :server-items-length="pagination.total"
        @update:page="buscarVentasPagosParciales"
      >
        <template v-slot:item.total="{ item }">
          {{ '$ '+formatNumber(item.total) }}
        </template>
        <template v-slot:item.acciones="{ item }">
          <router-link :to="'/pagos-parciales/ver-abonos/'+item.id" icon small color="primary">
            <v-icon>mdi-eye</v-icon>
          </router-link>     
        </template>

        <template v-slot:no-data>
          No se encontraron ventas.
        </template>
      </v-data-table>
      <div v-else>
        <p>No hay ventas para mostrar, por favor realice una consulta o verifique los datos.</p>
      </div>
    </v-container>
  </v-app>
</template>
<script>
import moment from "moment";
moment.locale("es");

import axios from 'axios';
import { configApi } from '../api/configApi';
import { headers } from '../api/headers';

export default {
  data() {
    return {
      data_busqueda: {
        tipo_identificacion: null,
        numero_identificacion: null,
        numero_venta: null
      },
      venta_pago_parcial: [],
      search: "",
      show_limpiarbusqueda: false,
      show_select: false,
      abonar_venta: false,
      numero_venta: null,
      venta: null,
      headers: [
        { text: "ID", value: "id" },
        { text: "Nombre Cliente", value: "nombre" },
        { text: "Apellidos Cliente", value: "apellidos" },
        { text: "Identificación", value: "identificacion" },
        { text: "Fecha Venta", value: "fecha" },
        { text: "Valor de Venta", value: "total" },
        { text: "Acciones", value: "acciones", sortable: false },
      ],
      loading: false,
      codeVoucher: null,
      formaPago: "efectivo",
      montoTarjeta: 0,
      montoEfectivo: 0,
      formaPagoTarjeta: "debito",
      formasPago: [
        {
          text: "Efectivo",
          value: "efectivo",
        },
        {
          text: "Tarjeta",
          value: "tarjeta",
        },
        {
          text: "Mixto",
          value: "mixto",
        },
      ],
      formasPagoTarjeta: [
        {
          text: "Credito",
          value: "credito",
        },
        {
          text: "Debito",
          value: "debito",
        },
      ],
      efectivoRecibido: 0,
      tiposEntregaBoletas: [
        {
          text: "DIGITAL",
          value: "digital",
        },
        {
          text: "FISICA",
          value: "fisica",
        },
        {
          text: "TAQUILLA",
          value: "taquilla",
        },
        {
          text: "DOMICILIO",
          value: "domicilio",
        },
      ],
      montoAbonoPagoParcial: 0,
      pagination: {
        current_page: 1,
        per_page: 10,
        total: 0,
      },
    };
  },
  async beforeCreate() {
    document.title = "Pagos parciales - TicketShop";
    //await this.$store.dispatch('carrito/pagosParciales',{'page':1,'iden':null,'hasta':null,'id_evento':null});
    await this.$store.dispatch("user/listTipoIdentificaciones");
    this.$store.dispatch("departamento/listDepartamentos");
    this.$store.dispatch("ciudad/listCiudades");
    var self = this;
    setTimeout(function () {
      self.show_select = true;
    }, 250);
  },
  computed: {
    tipoIdentificaciones() {
      return this.$store.getters["user/listTipoIdentificaciones"];
    },
  },
  methods: {
    limpiarBusqueda() {
      this.data_busqueda.tipo_identificacion = null
      this.data_busqueda.numero_identificacion = null
      this.data_busqueda.numero_venta = null
      this.show_limpiarbusqueda = false
      this.venta_pago_parcial = []
    },  
    formatNumber(number) {
      return new Intl.NumberFormat("es-CO", {
        minimumFractionDigits: 0,
      }).format(number);
    },
    printFactura() {
      // Pass the element id here
      this.$htmlToPaper("printFactura");
    },
    formatoMoneda(valor) {
      if (valor != null && valor != "") {
        return new Intl.NumberFormat("es-CO").format(valor);
      } else {
        return "";
      }
    },
    formatFechaHumans(fecha) {
      return moment(fecha).fromNow();
    },
    async buscarVentasPagosParciales() {      
      if (
        this.data_busqueda.tipo_identificacion != null 
      ) {
        //
        this.show_limpiarbusqueda = true
        await axios.post(`${configApi.apiUrl}obtener_ventas_pagos_parciales`, this.data_busqueda, { headers: headers })
        .then(response => {          
          
          this.venta_pago_parcial = response.data.data.data;
          this.pagination.total = response.data.total;
          this.pagination.per_page = response.data.per_page;
          this.pagination.current_page = response.data.current_page;
          
        })

      } else {
        swal(
          "Error!",
          "Completa los campos para realizar la busqueda!",
          "error"
        );
      }
    },
    searchFactura(id) {
      this.$store.dispatch("carrito/searchFactura", id);
    },
    limpiarUser() {
      this.$store.dispatch("carrito/limpiarUserSale", false);
    },
    abonarVenta(id) {
      this.abonar_venta = false;
      this.venta = null;
      this.formaPago = "efectivo";
      this.abonar_venta = true;
      this.montoAbonoPagoParcial = 0;
      this.venta = this.pagosParciales.filter((item) => item.id == id)[0];
      //$("html, body").animate({ scrollTop: 700 }, 1000);
    },
    getTotalVenta(detalle_vents, abonado) {
      var totalVenta = 0;
      for (var i = 0; i < detalle_vents.length; i++) {
        totalVenta +=
          detalle_vents[i].precio_servicio +
          detalle_vents[i].precio_venta +
          (detalle_vents[i].precio_servicio + detalle_vents[i].precio_venta) *
            detalle_vents[i].impuesto;
      }
      return totalVenta - abonado;
    },
    changeFormaPago() {
      if (this.formaPago == "mixto") {
        this.montoTarjeta =
          this.getTotalVenta(
            this.venta.detalle_vents,
            this.getTotalAbonado(this.venta.id)
          ) / 2;
        this.montoEfectivo =
          this.getTotalVenta(
            this.venta.detalle_vents,
            this.getTotalAbonado(this.venta.id)
          ) / 2;
      }
    },
    validateSumaPagoMixto() {
      var self = this;
      setTimeout(function () {
        if (
          self.montoEfectivo + self.montoTarjeta >
          self.getTotalVenta(
            this.venta.detalle_vents,
            self.getTotalAbonado(this.venta.id)
          )
        ) {
          self.montoTarjeta =
            self.getTotalVenta(
              this.venta.detalle_vents,
              self.getTotalAbonado(this.venta.id)
            ) / 2;
          self.montoEfectivo =
            self.getTotalVenta(
              this.venta.detalle_vents,
              self.getTotalAbonado(this.venta.id)
            ) / 2;
        }
      }, 1);
    },

    validateMontoPagoParcial() {
      var self = this;
      setTimeout(function () {
        if (
          self.montoAbonoPagoParcial >
          self.getTotalVenta(
            self.venta.detalle_vents,
            self.getTotalAbonado(self.venta.id)
          )
        ) {
          self.montoAbonoPagoParcial = 0;
        }
      }, 1);
    },
    getTotalAbonado(id) {
      var abonos = this.pagosParciales.filter((item) => item.id == id)[0];
      var totalAbonado = abonos.total;

      for (var i = 0; i < abonos.abonos_venta_parcial.length; i++) {
        totalAbonado +=
          abonos.abonos_venta_parcial[i].monto_efectivo +
          abonos.abonos_venta_parcial[i].monto_tarjeta;
      }
      return totalAbonado;
    },
    updateVenta() {
      var self = this;
      swal({
        title: "¿Esta seguro de confirmar el abono a la venta?",
        text: "",
        icon: "warning",
        buttons: ["No, cancelar", "Confirmar"],
        closeModal: true,
      }).then((willDelete) => {
        if (willDelete) {
          self.$store
            .dispatch("carrito/updateVentaPagoParcial", {
              venta_id: self.venta.id,
              monto_abono_pago_parcial: self.montoAbonoPagoParcial,
              datosPago: {
                formaPago: self.formaPago,
                formaPagoTarjeta: self.formaPagoTarjeta,
                montoTarjeta: self.montoTarjeta,
                montoEfectivo: self.montoEfectivo,
                codeVoucher: self.codeVoucher,
              },
            })
            .then(() => {
              self.limpiarUser();
              self.montoAbonoPagoParcial = 0;
              self.codeVoucher = null;
              self.abonar_venta = false;
              self.venta = null;
              self.formaPago = "efectivo";
              self.abonar_venta = false;
              self.montoAbonoPagoParcial = 0;
              $("html, body").animate({ scrollTop: 0 }, 1000);
            });
        }
      });
    },
  },
};
</script>
<style>
.elevation-1.table-ventas table thead {
  background-color: #cacaca;
}
.elevation-1.table-ventas table thead th {
  color: black;
  font-weight: bold;
}
.elevation-1.table-ventas table tbody td {
  color: black;
  font-size: 16px;
}
</style>